export default __webpack_public_path__ + "static/media/turkey_grayscale.3faa1cc3.svg";